<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="printer group"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:save="save"
          v-bind:row="edit"
          v-bind:remove="remove"
          v-bind:add_button_name="'add_printer_group'"
          v-bind:saveDisabled="!is_valid"
        >
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field v-model="printer.name" :label="$t('name')" :rules="[fieldRules.required]" />
            </v-card-text>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
export default {
  name: "SettingsPinters",
  data: () => ({
    printer_edit_index: -1,
    is_valid: false,
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Count", value: "count", align: "right" }
    ],
    printer: {
      name: null
    },
    data: [],
    page: 1,
    totalPages: null
  }),
  methods: {
    async remove(items) {
      const indeces = [];
      for (const index in items) {
        indeces.push(items[index]._id);
      }
      await this.$communicator("remove_printers", {
        params: {
          indexes: indeces
        }
      });
      this.update();
    },
    edit(item) {
      if (item == null) {
        this.printer_edit_index = -1;
        this.printer = {
          name: null
        };
      } else {
        this.printer_edit_index = item._id;
        this.printer.name = item.name;
      }
    },
    async save() {
      if (this.printer_edit_index == -1) {
        await this.$communicator("create_printer", {
          params: this.printer
        });
      } else {
        await this.$communicator("update_printer", {
          arguments: [this.printer_edit_index],
          params: this.printer
        });
      }
      this.update();
    },
    async update() {
      const printers = this.$communicator.then(
        this,
        await this.$communicator("printers", {
          arguments: [10, this.page],
          params: { service: "" }
        })
      );
      if (printers) {
        this.totalPages = printers.page;
        this.data = printers.data;
      }
    }
  },
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", align: "left", available: true },
      { text: this.$t("count"), value: "count", align: "right" , available: true}
    ]
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  }
};
</script>